import {useNavigation} from 'react-router-dom';
import {Status} from '../enums/status';
import {RootState, useAppSelector} from '../store/store';

export function useIsNavigatingOrPending(statusSelector: (state: RootState) => Status) {
    const status = useAppSelector(statusSelector);
    const navigation = useNavigation();
    return navigation.state === 'loading' || navigation.state === 'submitting' || status === Status.PENDING;
}
